import React from "react"

export default function globalComponents() {
	return []
}